import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Optional,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroupDirective, FormsModule, NgControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import {
  MatError,
  MatFormField,
  MatFormFieldControl,
  MatHint,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import moment from 'moment';
import { MatBaseInputComponent } from '../mat-base-input.component';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldFix } from '../mat-form-field/mat-form-field-fix';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    console.log('isErrorState', control, form, isSubmitted);
    return control && control.invalid;
  }
}

@Component({
  selector: 'app-mat-time-picker',
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: MatTimePickerComponent,
    },
    { provide: ErrorStateMatcher, useClass: MyErrorStateMatcher },
  ],
  template: `
    <mat-form-field
      class="regular-form-field"
      [ngClass]="{
        inline: inlineLabel,
        'no-label': inlineLabel,
        'mat-form-field-invalid': formControl?.invalid,
      }"
      [appearance]="appearance"
      (focusin)="onFocusIn($event)"
      (focusout)="onFocusOut($event)"
    >
      <mat-label>{{ label }}</mat-label>

      <input
        [value]="displayValue"
        (input)="onInputChange($event)"
        (keypress)="onInputKeyPress($event)"
        (keydown.enter)="onInputEnter($event)"
        (blur)="onInputBlur($event)"
        [placeholder]="placeholder ? placeholder : inlineLabel ? label : ''"
        [id]="_id"
        [name]="name"
        [readonly]="readonly || submitted"
        autocomplete="off"
        class="mat-input-element mat-form-field-autofill-control mdc-text-field__input"
        style="background: transparent; border: none; outline: none; box-shadow: none; font: inherit; color: inherit; width: 100%; padding: 0; margin: 0; height: 1.4375em;"
      />
      <input matInput hidden="hidden" [formControl]="formControl" />
      <mat-icon
        matSuffix
        (click)="togglePopup(); $event.stopPropagation()"
        style="cursor:pointer"
        [ngClass]="{ 'icon-disabled': submitted }"
        >schedule</mat-icon
      >
      <div class="time-picker-popup" *ngIf="popupOpen" #popup>
        <div class="scroller-group" style="display: flex; align-items: center; justify-content: center; height: 100%;">
          <div class="scroller simulated-scroller" (wheel)="onWheel('hour', $event)">
            <button mat-icon-button type="button" class="scroll-btn" (click)="onSimulatedScroll('hour', 'down')">
              <mat-icon>expand_less</mat-icon>
            </button>
            <div class="scroller-value faded-grey" (click)="selectHour(getPrevValue('hour', 1))">
              {{ hDisplay(getPrevValue('hour', 1)) || ' ' }}
            </div>
            <div class="scroller-value selected">{{ hDisplay(selectedHour) }}</div>
            <div class="scroller-value faded-grey" (click)="selectHour(getNextValue('hour', 1))">
              {{ hDisplay(getNextValue('hour', 1)) || ' ' }}
            </div>
            <button mat-icon-button type="button" class="scroll-btn" (click)="onSimulatedScroll('hour', 'up')">
              <mat-icon>expand_more</mat-icon>
            </button>
          </div>
          <div class="scroller simulated-scroller" (wheel)="onWheel('minute', $event)">
            <button mat-icon-button type="button" class="scroll-btn" (click)="onSimulatedScroll('minute', 'down')">
              <mat-icon>expand_less</mat-icon>
            </button>
            <div class="scroller-value faded-grey" (click)="selectMinute(getPrevValue('minute', 1))">
              {{ getPrevValue('minute', 1) !== '' ? (getPrevValue('minute', 1) | number: '2.0') : ' ' }}
            </div>
            <div class="scroller-value selected">{{ selectedMinute | number: '2.0' }}</div>
            <div class="scroller-value faded-grey" (click)="selectMinute(getNextValue('minute', 1))">
              {{ getNextValue('minute', 1) !== '' ? (getNextValue('minute', 1) | number: '2.0') : ' ' }}
            </div>
            <button mat-icon-button type="button" class="scroll-btn" (click)="onSimulatedScroll('minute', 'up')">
              <mat-icon>expand_more</mat-icon>
            </button>
          </div>
          <div class="scroller simulated-scroller" *ngIf="showSeconds" (wheel)="onWheel('second', $event)">
            <button mat-icon-button type="button" class="scroll-btn" (click)="onSimulatedScroll('second', 'down')">
              <mat-icon>expand_less</mat-icon>
            </button>
            <div class="scroller-value faded-grey" (click)="selectSecond(getPrevValue('second', 1))">
              {{ getPrevValue('second', 1) !== '' ? (getPrevValue('second', 1) | number: '2.0') : ' ' }}
            </div>
            <div class="scroller-value selected">{{ selectedSecond | number: '2.0' }}</div>
            <div class="scroller-value faded-grey" (click)="selectSecond(getNextValue('second', 1))">
              {{ getNextValue('second', 1) !== '' ? (getNextValue('second', 1) | number: '2.0') : ' ' }}
            </div>
            <button mat-icon-button type="button" class="scroll-btn" (click)="onSimulatedScroll('second', 'up')">
              <mat-icon>expand_more</mat-icon>
            </button>
          </div>
          <div class="scroller" *ngIf="format === '12'">
            <div (click)="selectAmPm('AM')" [class.selected]="amPm === 'AM'">AM</div>
            <div (click)="selectAmPm('PM')" [class.selected]="amPm === 'PM'">PM</div>
          </div>
        </div>
        <button type="button" class="ok-btn" (click)="confirm()">SET</button>
      </div>
      <mat-error>{{ firstError() }}</mat-error>
      <mat-hint align="start" *ngIf="!formControl.invalid">{{ infoText }}</mat-hint>
    </mat-form-field>
  `,
  styleUrls: ['./mat-time-picker.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    NgClass,
    NgIf,
    MatSuffix,
    MatError,
    MatHint,
    FormsModule,
    ReactiveFormsModule,
    MatIconButton,
    MatFormFieldFix,
  ],
})
export class MatTimePickerComponent extends MatBaseInputComponent implements AfterViewInit {
  @Input() format: '12' | '24' = '24';
  @Input() showSeconds = false;
  @Input() hint = '';

  @Output() valueChange = new EventEmitter<moment.Moment>();

  @ViewChild('popup') popupRef!: ElementRef;

  matcher = new MyErrorStateMatcher();

  popupOpen = false;
  selectedHour = 0;
  selectedMinute = 0;
  selectedSecond = 0;
  amPm: 'AM' | 'PM' = 'AM';

  inputError: string | null = null;

  private _value: moment.Moment | null = null;

  //onChange = (value: any) => {};
  //onTouched = () => {};

  constructor(
    @Optional() public ngControl: NgControl,
    public _elementRef: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef,
  ) {
    super(ngControl, _elementRef);
    // Set the default time to now if no value is provided
    if (!this._value) {
      this._value = moment();
      this.writeValue(this._value);
    }
  }

  get hours(): number[] {
    return this.format === '12' ? Array.from({ length: 12 }, (_, i) => i + 1) : Array.from({ length: 24 }, (_, i) => i);
  }

  get minutes(): number[] {
    return Array.from({ length: 60 }, (_, i) => i);
  }

  get seconds(): number[] {
    return Array.from({ length: 60 }, (_, i) => i);
  }

  get displayValue(): string {
    if (this.formControl && this.formControl.value) {
      const val = this.formControl.value;
      if (moment.isMoment(val)) {
        let hour = val.hour();
        let minute = val.minute();
        let second = val.second();
        let ampm = '';
        if (this.format === '12') {
          ampm = hour >= 12 ? ' PM' : ' AM';
          hour = hour % 12;
          if (hour === 0) {
            hour = 12;
          }
        }
        let hStr = hour.toString().padStart(2, '0');
        let mStr = minute.toString().padStart(2, '0');
        let sStr = second.toString().padStart(2, '0');
        let time = `${hStr}:${mStr}`;
        if (this.showSeconds) {
          time += `:${sStr}`;
        }
        if (this.format === '12') {
          time += ampm;
        }

        console.log('displayValue', time);
        return time;
      } else if (typeof val === 'string') {
        return val;
      }
    }
    // fallback to selected values
    let h = this.selectedHour;
    let m = this.selectedMinute;
    let s = this.selectedSecond;
    let hStr = this.hDisplay(h);
    let mStr = m.toString().padStart(2, '0');
    let sStr = s.toString().padStart(2, '0');
    let time = `${hStr}:${mStr}`;
    if (this.showSeconds) {
      time += `:${sStr}`;
    }
    if (this.format === '12') {
      time += ` ${this.amPm}`;
    }
    return time;
  }

  openPopup() {
    this.popupOpen = true;
  }

  ngAfterViewInit() {
    // Ensure initial value is respected after view is initialized
    if (this._value instanceof Date) {
      this.writeValue(this._value);
    }
  }

  selectHour(h: number | string) {
    this.selectedHour = Number(h);
  }

  selectMinute(m: number | string) {
    this.selectedMinute = Number(m);
  }

  selectSecond(s: number | string) {
    this.selectedSecond = Number(s);
  }

  selectAmPm(val: 'AM' | 'PM') {
    this.amPm = val;
  }

  /**
   * Create a moment value using the currently selected hour/min/sec (and AM/PM),
   * with seconds/millis normalized.
   */
  private buildMomentFromSelection(): moment.Moment {
    let hour = this.selectedHour;
    if (this.format === '12') {
      if (this.amPm === 'PM' && hour < 12) {
        hour += 12;
      }
      if (this.amPm === 'AM' && hour === 12) {
        hour = 0;
      }
    }

    const base = this._value && moment.isMoment(this._value) ? this._value.clone() : moment();
    return base.set({
      hour,
      minute: this.selectedMinute,
      second: this.showSeconds ? this.selectedSecond : 0,
      millisecond: 0,
    });
  }

  /**
   * Commit the given moment to CVA + output events.
   * This is the single source of truth for updating the parent form.
   */
  private commitValue(val: moment.Moment, markTouched = true) {
    this._value = val;
    this.valueChange.emit(val);
    this.onChange(val);
    if (markTouched) {
      this.onTouched();
    }
  }

  confirm() {
    const next = this.buildMomentFromSelection();
    this.commitValue(next);
    this.popupOpen = false;
    this.cdr.detectChanges();
  }

  preventInput(event: KeyboardEvent) {
    event.preventDefault();
  }

  onInputChange(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    // Accepts formats: HH:mm, HH:mm:ss, HH:mm AM/PM, etc.
    const timeRegex = this.showSeconds
      ? /^([01]?\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\s?(AM|PM))?$/i
      : /^([01]?\d|2[0-3]):([0-5]\d)(?:\s?(AM|PM))?$/i;
    const match = input.match(timeRegex);
    if (match) {
      let hour = parseInt(match[1], 10);
      let minute = parseInt(match[2], 10);
      let second = this.showSeconds ? parseInt(match[3], 10) : 0;
      const ampm = this.format === '12' ? (this.showSeconds ? match[4] : match[3]) : undefined;
      if (this.format === '12' && ampm) {
        this.amPm = ampm.toUpperCase() === 'PM' ? 'PM' : 'AM';
        if (this.amPm === 'PM' && hour < 12) {
          hour += 12;
        }
        if (this.amPm === 'AM' && hour === 12) {
          hour = 0;
        }
      }
      this.selectedHour = hour;
      this.selectedMinute = minute;
      this.selectedSecond = second;
      this.inputError = null;
      if (this.formControl) {
        this.formControl.setErrors(null);
        this.formControl.markAsTouched();
      }
    } else {
      this.inputError = this.showSeconds
        ? 'Invalid time format. Use HH:mm:ss' + (this.format === '12' ? ' AM/PM' : '')
        : 'Invalid time format. Use HH:mm' + (this.format === '12' ? ' AM/PM' : '');
      if (this.formControl) {
        this.formControl.setErrors({ timeFormat: this.inputError });
        this.formControl.markAsTouched();
      }
    }
  }

  /**
   * Allow digits, colon, space and AM/PM letters for manual typing.
   * We still validate full format in onInputChange().
   */
  onInputKeyPress(event: KeyboardEvent) {
    const allowed = /[0-9:apm\s]/i;
    if (!allowed.test(event.key)) {
      event.preventDefault();
    }
  }

  /** Commit typed input on blur/enter if valid. */
  private commitTypedIfValid() {
    if (this.inputError) {
      return;
    }
    // If current text matches the regex it already updated selection.
    const next = this.buildMomentFromSelection();
    this.commitValue(next);
  }

  onInputEnter(event: Event) {
    // Template may type this as plain Event depending on Angular versions.
    (event as KeyboardEvent).preventDefault?.();
    this.commitTypedIfValid();
  }

  onInputBlur(event: FocusEvent) {
    this.commitTypedIfValid();
    // keep base behavior
    this.onTouched();
  }

  hDisplay(h: number | string): string {
    if (h === '' || h === null || h === undefined) {
      return '';
    }
    if (this.format === '12') {
      return h.toString();
    }
    return h.toString().padStart(2, '0');
  }

  writeValue(value: moment.Moment | null): void {
    this._value = value;
    if (moment.isMoment(value)) {
      let hour = value.hour();
      const minute = value.minute();
      const second = value.second();
      if (this.format === '12') {
        this.amPm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        if (hour === 0) {
          hour = 12;
        }
      }
      this.selectedHour = hour;
      this.selectedMinute = minute;
      this.selectedSecond = second;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Simulate scroll by increasing or decreasing the selected value by one
  onSimulatedScroll(type: 'hour' | 'minute' | 'second', direction: 'up' | 'down') {
    if (type === 'hour') {
      const idx = this.hours.indexOf(this.selectedHour);
      if (direction === 'up' && idx < this.hours.length - 1) {
        this.selectHour(this.hours[idx + 1]);
      } else if (direction === 'down' && idx > 0) {
        this.selectHour(this.hours[idx - 1]);
      }
    }
    if (type === 'minute') {
      const idx = this.minutes.indexOf(this.selectedMinute);
      if (direction === 'up' && idx < this.minutes.length - 1) {
        this.selectMinute(this.minutes[idx + 1]);
      } else if (direction === 'down' && idx > 0) {
        this.selectMinute(this.minutes[idx - 1]);
      }
    }
    if (type === 'second') {
      const idx = this.seconds.indexOf(this.selectedSecond);
      if (direction === 'up' && idx < this.seconds.length - 1) {
        this.selectSecond(this.seconds[idx + 1]);
      } else if (direction === 'down' && idx > 0) {
        this.selectSecond(this.seconds[idx - 1]);
      }
    }
  }

  onWheel(type: 'hour' | 'minute' | 'second', event: WheelEvent) {
    event.preventDefault();
    if (event.deltaY > 0) {
      this.onSimulatedScroll(type, 'up');
    } else if (event.deltaY < 0) {
      this.onSimulatedScroll(type, 'down');
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.popupOpen) {
      return;
    }
    if (!this.popupRef?.nativeElement.contains(event.target)) {
      this.popupOpen = false;
    }
  }

  getPrevValue(type: 'hour' | 'minute' | 'second', offset: number): number | string {
    if (type === 'hour') {
      const idx = this.hours.indexOf(this.selectedHour) - offset;
      return idx >= 0 ? this.hours[idx] : '';
    }
    if (type === 'minute') {
      const idx = this.minutes.indexOf(this.selectedMinute) - offset;
      return idx >= 0 ? this.minutes[idx] : '';
    }
    if (type === 'second') {
      const idx = this.seconds.indexOf(this.selectedSecond) - offset;
      return idx >= 0 ? this.seconds[idx] : '';
    }
    return '';
  }

  getNextValue(type: 'hour' | 'minute' | 'second', offset: number): number | string {
    if (type === 'hour') {
      const idx = this.hours.indexOf(this.selectedHour) + offset;
      return idx < this.hours.length ? this.hours[idx] : '';
    }
    if (type === 'minute') {
      const idx = this.minutes.indexOf(this.selectedMinute) + offset;
      return idx < this.minutes.length ? this.minutes[idx] : '';
    }
    if (type === 'second') {
      const idx = this.seconds.indexOf(this.selectedSecond) + offset;
      return idx < this.seconds.length ? this.seconds[idx] : '';
    }
    return '';
  }

  get showInputError(): boolean {
    return !!this.inputError;
  }

  togglePopup() {
    if (this.submitted) return;
    this.popupOpen = !this.popupOpen;
  }
}
